import { useEffect, useState } from "react";
import { FeatureGroup } from "react-leaflet";
import { LandPriceTileLayer } from "./mapLibre/layers/LandPriceTileLayer";

interface Props {
  defaultVisible: boolean;
  initialZoomLevel: number;
  visible?: boolean;
}

export const LAND_PRICE_LAYER_NAME = "公示価格を表示する";

/*
AreaUsePurposeTileLayerをLeafletのLayersControlで制御するためのWrapperコンポーネント
*/
export const LandPriceLayerControlWrapper: React.FC<Props> = ({
  defaultVisible,
  initialZoomLevel,
  visible: visibleProp,
}) => {
  const [visible, setVisible] = useState(defaultVisible);

  useEffect(() => {
    if (typeof visibleProp === "boolean") {
      setVisible(visibleProp);
    }
  }, [visibleProp]);

  return (
    <>
      {/* 空のFeatureGroupは、LayersControlに認識させるために必要 */}
      <FeatureGroup />
      <LandPriceTileLayer
        visible={visible}
        initialZoomLevel={initialZoomLevel}
      />
    </>
  );
};
